import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  prettyBytes,
  insertUrlParam,
  makeRequest,
  timestampToLocaleString,
  useQuery
} from '../../utils';
import useAPIData from '../../hooks/useAPIData';
import Header from '../Header/Header';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { s3DownloadURL, makePath } from './bucketViewHelpers';

export default function BucketView() {
  const prefix = useQuery().get('s3_prefix') || '';
  const results = useAPIData(`/nld_tracker/s3/list?prefix=${prefix}`);
  const [uploadFile, setUploadFile] = useState(null);
  const [isLoaded, setIsLoaded] = useState(true);

  const handleS3Download = async (key) => {
    const downloadURL = await s3DownloadURL(encodeURIComponent(key));
    window.location.href = downloadURL;
  };

  const handleS3Upload = (e) => {
    e.preventDefault();
    if (uploadFile) {
      setIsLoaded(false);

      const p = prefix.endsWith('/') || prefix === '' ? prefix : prefix + '/';
      const s3Key = encodeURIComponent(`${p}${uploadFile.name}`);
      const url = `/nld_tracker/s3/stream_upload?key=${s3Key}`;
      const requestArgs = {
        method: 'POST',
        body: uploadFile
      };
      const contentType = 'application/octet-stream';

      makeRequest(url, requestArgs, contentType)
        .then((data) => {
          setIsLoaded(true);
          alert('Successfully uploaded a file!');
          window.location.reload();
        })
        .catch((e) => {
          setIsLoaded(true);
          alert(`Error uploading file: ${e}`);
        });
    } else {
      alert('No file selected.');
    }
  };

  useEffect(() => {
    if (prefix === '') {
      insertUrlParam('s3_prefix', '');
    }
  }, [prefix]);

  const createTable = (r) => {
    const dateStr = timestampToLocaleString(r.modified);
    if (!r.isdir) {
      return (
        <tr key={r.id}>
          <td>{r.fileName}</td>
          <td>
            <span
              className='like-anchor'
              onClick={() => {
                handleS3Download(`${r.filePath}/${r.fileName}`);
              }}
            >
              Download
            </span>
          </td>

          {r.type === '.gpkg' ? (
            <td>
              <span
                className='like-anchor'
                onClick={async () => {
                  const resp = await makeRequest(
                    `/nld_tracker/background/reprocess?gpkg=${encodeURIComponent(
                      r.filePath + '/' + r.fileName
                    )}`
                  );
                  alert(resp);
                }}
              >
                Reprocess
              </span>
            </td>
          ) : (
            <td> -- </td>
          )}
          {r.type === '.gpkg' ? (
            <td>
              <span
                className='like-anchor'
                onClick={async () => {
                  const resp = await makeRequest(
                    `/nld_tracker/background/compute_leveed_area?gpkg=${encodeURIComponent(
                      r.filePath + '/' + r.fileName
                    )}`
                  );
                  alert(resp);
                }}
              >
                Compute
              </span>
            </td>
          ) : (
            <td> -- </td>
          )}
          {r.type === '.gpkg' ? (
            <td>
              <span
                className='like-anchor'
                onClick={async () => {
                  const resp = await makeRequest(
                    `/nld_tracker/background/create_report?gpkg=${encodeURIComponent(
                      r.filePath + '/' + r.fileName
                    )}`
                  );
                  alert(resp);
                }}
              >
                Create
              </span>
            </td>
          ) : (
            <td> -- </td>
          )}
          {[
            '.csv',
            '.txt',
            '.png',
            '.jpg',
            '.jpeg',
            '.log',
            '.json',
            '.py'
          ].includes(r.type.toLowerCase()) ? (
            <td>
              <a
                target='_self'
                rel='noreferrer'
                href={`/fileview?key=${encodeURIComponent(
                  r.filePath + '/' + r.fileName
                )}`}
              >
                View
              </a>
            </td>
          ) : r.type.toLowerCase() === '.html' ? (
            <td>
              <span
                className='like-anchor'
                onClick={() => {
                  handleS3Download(`${r.filePath}/${r.fileName}`);
                }}
              >
                View
              </span>
            </td>
          ) : (
            <td> -- </td>
          )}

          <td>{dateStr}</td>
          <td>{prettyBytes(r.size)}</td>
        </tr>
      );
    } else {
      return (
        <tr key={r.id}>
          <td>
            <a href={`/bucketview?s3_prefix=${encodeURIComponent(r.filePath)}`}>
              &#128193; {r.fileName}
            </a>
          </td>
          <td> -- </td>
          <td> -- </td>
          <td> -- </td>
          <td> -- </td>
          <td> -- </td>
          <td> -- </td>
          <td> -- </td>
        </tr>
      );
    }
  };

  return (
    <div className='bucket-view'>
      <Helmet>
        <title>BucketView · NLD Refinement</title>
      </Helmet>
      <Header />
      <br></br>
      <h3>Current Path: {makePath(prefix)}</h3>
      <br />
      <center>
        <form id='upload-files' onSubmit={handleS3Upload}>
          <h4>Upload file(s)</h4>
          <br />
          <br />
          <input
            type='file'
            id='files'
            name='files'
            onChange={(e) => setUploadFile(e.target.files[0])}
          />
          <br />
          <br />
          <button className='upload-btn' type='submit' id='uploadFileBtn'>
            Upload
          </button>
        </form>
        <br />
      </center>
      <table className='styled-table'>
        <thead>
          <tr>
            <th>Name</th>
            <th>Download Link</th>
            <th>Reprocess System</th>
            <th>Compute Leveed Area</th>
            <th>Create Report</th>
            <th>View</th>
            <th>Last Modified</th>
            <th>Size</th>
          </tr>
        </thead>
        {results && <tbody>{results.map(createTable)}</tbody>}
      </table>
      {!isLoaded && <LoadingSpinner />}
    </div>
  );
}
